import posthog from "posthog-js";
import { PostHogEnvironmentConfig } from "./posthog-config";

export function initPostHog(config: PostHogEnvironmentConfig): void {
  if (!config.apiKey) {
    return;
  }

  posthog.init(config.apiKey, {
    api_host: config.apiHost,
    person_profiles: "identified_only",
    capture_exceptions: true,
    capture_pageview: false,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "[data-ph-mask]",
    },
    logs: {
      captureConsoleLogs: true,
      serviceName: config.appName,
    },
  });

  posthog.register({
    app: config.appName,
    environment: config.environment,
  });
}
